module.exports = "./img/78c0c308a3d171f3454ce691f1148bf3.jpg";